(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1757,6818],{

/***/ 62034:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayPush = __webpack_require__(65067),
    isFlattenable = __webpack_require__(95882);

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */
function baseFlatten(array, depth, predicate, isStrict, result) {
  var index = -1,
      length = array.length;

  predicate || (predicate = isFlattenable);
  result || (result = []);

  while (++index < length) {
    var value = array[index];
    if (depth > 0 && predicate(value)) {
      if (depth > 1) {
        // Recursively flatten arrays (susceptible to call stack limits).
        baseFlatten(value, depth - 1, predicate, isStrict, result);
      } else {
        arrayPush(result, value);
      }
    } else if (!isStrict) {
      result[result.length] = value;
    }
  }
  return result;
}

module.exports = baseFlatten;


/***/ }),

/***/ 93401:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseEach = __webpack_require__(24303),
    isArrayLike = __webpack_require__(67878);

/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function baseMap(collection, iteratee) {
  var index = -1,
      result = isArrayLike(collection) ? Array(collection.length) : [];

  baseEach(collection, function(value, key, collection) {
    result[++index] = iteratee(value, key, collection);
  });
  return result;
}

module.exports = baseMap;


/***/ }),

/***/ 23813:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayMap = __webpack_require__(50343),
    baseGet = __webpack_require__(13324),
    baseIteratee = __webpack_require__(68286),
    baseMap = __webpack_require__(93401),
    baseSortBy = __webpack_require__(27095),
    baseUnary = __webpack_require__(47826),
    compareMultiple = __webpack_require__(18477),
    identity = __webpack_require__(23059),
    isArray = __webpack_require__(86152);

/**
 * The base implementation of `_.orderBy` without param guards.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
 * @param {string[]} orders The sort orders of `iteratees`.
 * @returns {Array} Returns the new sorted array.
 */
function baseOrderBy(collection, iteratees, orders) {
  if (iteratees.length) {
    iteratees = arrayMap(iteratees, function(iteratee) {
      if (isArray(iteratee)) {
        return function(value) {
          return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
        }
      }
      return iteratee;
    });
  } else {
    iteratees = [identity];
  }

  var index = -1;
  iteratees = arrayMap(iteratees, baseUnary(baseIteratee));

  var result = baseMap(collection, function(value, key, collection) {
    var criteria = arrayMap(iteratees, function(iteratee) {
      return iteratee(value);
    });
    return { 'criteria': criteria, 'index': ++index, 'value': value };
  });

  return baseSortBy(result, function(object, other) {
    return compareMultiple(object, other, orders);
  });
}

module.exports = baseOrderBy;


/***/ }),

/***/ 27095:
/***/ (function(module) {

/**
 * The base implementation of `_.sortBy` which uses `comparer` to define the
 * sort order of `array` and replaces criteria objects with their corresponding
 * values.
 *
 * @private
 * @param {Array} array The array to sort.
 * @param {Function} comparer The function to define sort order.
 * @returns {Array} Returns `array`.
 */
function baseSortBy(array, comparer) {
  var length = array.length;

  array.sort(comparer);
  while (length--) {
    array[length] = array[length].value;
  }
  return array;
}

module.exports = baseSortBy;


/***/ }),

/***/ 27520:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isSymbol = __webpack_require__(4795);

/**
 * Compares values to sort them in ascending order.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {number} Returns the sort order indicator for `value`.
 */
function compareAscending(value, other) {
  if (value !== other) {
    var valIsDefined = value !== undefined,
        valIsNull = value === null,
        valIsReflexive = value === value,
        valIsSymbol = isSymbol(value);

    var othIsDefined = other !== undefined,
        othIsNull = other === null,
        othIsReflexive = other === other,
        othIsSymbol = isSymbol(other);

    if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
        (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
        (valIsNull && othIsDefined && othIsReflexive) ||
        (!valIsDefined && othIsReflexive) ||
        !valIsReflexive) {
      return 1;
    }
    if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
        (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
        (othIsNull && valIsDefined && valIsReflexive) ||
        (!othIsDefined && valIsReflexive) ||
        !othIsReflexive) {
      return -1;
    }
  }
  return 0;
}

module.exports = compareAscending;


/***/ }),

/***/ 18477:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var compareAscending = __webpack_require__(27520);

/**
 * Used by `_.orderBy` to compare multiple properties of a value to another
 * and stable sort them.
 *
 * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
 * specify an order of "desc" for descending or "asc" for ascending sort order
 * of corresponding values.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {boolean[]|string[]} orders The order to sort by for each property.
 * @returns {number} Returns the sort order indicator for `object`.
 */
function compareMultiple(object, other, orders) {
  var index = -1,
      objCriteria = object.criteria,
      othCriteria = other.criteria,
      length = objCriteria.length,
      ordersLength = orders.length;

  while (++index < length) {
    var result = compareAscending(objCriteria[index], othCriteria[index]);
    if (result) {
      if (index >= ordersLength) {
        return result;
      }
      var order = orders[index];
      return result * (order == 'desc' ? -1 : 1);
    }
  }
  // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
  // that causes it, under certain circumstances, to provide the same value for
  // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
  // for more details.
  //
  // This also ensures a stable sort in V8 and other engines.
  // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
  return object.index - other.index;
}

module.exports = compareMultiple;


/***/ }),

/***/ 95882:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(50857),
    isArguments = __webpack_require__(79631),
    isArray = __webpack_require__(86152);

/** Built-in value references. */
var spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;

/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */
function isFlattenable(value) {
  return isArray(value) || isArguments(value) ||
    !!(spreadableSymbol && value && value[spreadableSymbol]);
}

module.exports = isFlattenable;


/***/ }),

/***/ 16760:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayMap = __webpack_require__(50343),
    baseIteratee = __webpack_require__(68286),
    baseMap = __webpack_require__(93401),
    isArray = __webpack_require__(86152);

/**
 * Creates an array of values by running each element in `collection` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
 *
 * The guarded methods are:
 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * _.map([4, 8], square);
 * // => [16, 64]
 *
 * _.map({ 'a': 4, 'b': 8 }, square);
 * // => [16, 64] (iteration order is not guaranteed)
 *
 * var users = [
 *   { 'user': 'barney' },
 *   { 'user': 'fred' }
 * ];
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, 'user');
 * // => ['barney', 'fred']
 */
function map(collection, iteratee) {
  var func = isArray(collection) ? arrayMap : baseMap;
  return func(collection, baseIteratee(iteratee, 3));
}

module.exports = map;


/***/ }),

/***/ 829:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseFlatten = __webpack_require__(62034),
    baseOrderBy = __webpack_require__(23813),
    baseRest = __webpack_require__(36060),
    isIterateeCall = __webpack_require__(82406);

/**
 * Creates an array of elements, sorted in ascending order by the results of
 * running each element in a collection thru each iteratee. This method
 * performs a stable sort, that is, it preserves the original sort order of
 * equal elements. The iteratees are invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {...(Function|Function[])} [iteratees=[_.identity]]
 *  The iteratees to sort by.
 * @returns {Array} Returns the new sorted array.
 * @example
 *
 * var users = [
 *   { 'user': 'fred',   'age': 48 },
 *   { 'user': 'barney', 'age': 36 },
 *   { 'user': 'fred',   'age': 30 },
 *   { 'user': 'barney', 'age': 34 }
 * ];
 *
 * _.sortBy(users, [function(o) { return o.user; }]);
 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
 *
 * _.sortBy(users, ['user', 'age']);
 * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
 */
var sortBy = baseRest(function(collection, iteratees) {
  if (collection == null) {
    return [];
  }
  var length = iteratees.length;
  if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
    iteratees = [];
  } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
    iteratees = [iteratees[0]];
  }
  return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
});

module.exports = sortBy;


/***/ }),

/***/ 59708:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ customer_success; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/dist/emotion-element-6a883da9.browser.esm.js + 1 modules
var emotion_element_6a883da9_browser_esm = __webpack_require__(28543);
// EXTERNAL MODULE: ../../libs/matcha/foundations/AppearanceContext/index.ts + 1 modules
var AppearanceContext = __webpack_require__(9381);
// EXTERNAL MODULE: ../../libs/templates/Footer/index.ts
var Footer = __webpack_require__(4009);
// EXTERNAL MODULE: ../../libs/templates/Navigation/index.ts + 91 modules
var Navigation = __webpack_require__(87303);
// EXTERNAL MODULE: ../../libs/templates/LogoTiles/index.ts + 1 modules
var LogoTiles = __webpack_require__(20442);
// EXTERNAL MODULE: ../../libs/templates/LogoTiles/LogoTiles.views.tsx
var LogoTiles_views = __webpack_require__(2432);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(20406);
// EXTERNAL MODULE: ../../node_modules/lodash/map.js
var map = __webpack_require__(16760);
var map_default = /*#__PURE__*/__webpack_require__.n(map);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(28526);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ../../libs/utils/createQueryHook/createQueryHook.ts
var createQueryHook = __webpack_require__(74048);
// EXTERNAL MODULE: ../../libs/utils/fsCache/index.ts
var fsCache = __webpack_require__(96904);
// EXTERNAL MODULE: ../../libs/contexts/staticSiteBackend.ts
var contexts_staticSiteBackend = __webpack_require__(86708);
;// CONCATENATED MODULE: ../../libs/api/routes/customerSuccessEvent/queries/eventsQuery.ts
/* provided dependency */ var process = __webpack_require__(34406);







var fetchEvents = /*#__PURE__*/function () {
  var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(client) {
    var filters,
        searchParams,
        result,
        todaysDate,
        _args = arguments;
    return regenerator_default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            filters = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};
            searchParams = new URLSearchParams();

            map_default()(filters, function (value, key) {
              var filterParams = value.map(function (item) {
                return item.value;
              });
              searchParams.set("fields.".concat(key).concat(filterParams.length === 1 ? "[all]" : filterParams.length > 1 ? "[in]" : ""), filterParams.toString());
            });

            _context.next = 5;
            return client.get("/content/entries/event?fields.customerSuccessTeamEvent=true&".concat(searchParams.toString()));

          case 5:
            result = _context.sent;
            todaysDate = new Date();
            todaysDate.setHours(0, 0, 0, 0);
            return _context.abrupt("return", toMonthlyEvents(result, todaysDate));

          case 9:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function fetchEvents(_x) {
    return _ref.apply(this, arguments);
  };
}();
var fetchPastEvents = /*#__PURE__*/function () {
  var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2(client) {
    var result, todaysDate;
    return regenerator_default().wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return client.get("/content/entries/event?fields.customerSuccessTeamEvent=true");

          case 2:
            result = _context2.sent;
            todaysDate = new Date();
            todaysDate.setHours(0, 0, 0, 0);
            return _context2.abrupt("return", getPastEvents(result, todaysDate));

          case 6:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function fetchPastEvents(_x2) {
    return _ref2.apply(this, arguments);
  };
}();
var createFetchEventsQuery = function createFetchEventsQuery(client, _ref3) {
  var filters = _ref3.filters;
  return [["events", "fetchEvents", filters !== null && filters !== void 0 ? filters : null], /*#__PURE__*/(0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee3() {
    var events;
    return regenerator_default().wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return fetchEvents(client, filters);

          case 2:
            events = _context3.sent;
            return _context3.abrupt("return", events);

          case 4:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }))];
};
var useEventsQuery = (0,createQueryHook/* default */.Z)(createFetchEventsQuery, contexts_staticSiteBackend/* useStaticSiteBackend */.gR, {
  staleTime: Infinity,
  keepPreviousData: true
});
var createFetchPastEventsQuery = function createFetchPastEventsQuery(client) {
  return [["events", "fetchPastEvents"], /*#__PURE__*/(0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee4() {
    var events;
    return regenerator_default().wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return fetchPastEvents(client);

          case 2:
            events = _context4.sent;
            return _context4.abrupt("return", events);

          case 4:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }))];
};
var usePastEventsQuery = (0,createQueryHook/* default */.Z)(createFetchPastEventsQuery, contexts_staticSiteBackend/* useStaticSiteBackend */.gR, {
  staleTime: Infinity,
  keepPreviousData: true
});
var fetchFeaturedEventData = /*#__PURE__*/function () {
  var _ref6 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee5(client) {
    var enabled, filterParams, cachedFetch;
    return regenerator_default().wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            enabled = Boolean(process.env.ENABLE_FS_CACHE);
            filterParams = new URLSearchParams();
            filterParams.set("fields.featured", "true");
            filterParams.set("order", "fields.startDate");
            _context5.next = 6;
            return (0,fsCache/* createFsCacheProxy */.c)(["featuredEvent"], function () {
              return client.get("/content/entries/event?fields.customerSuccessTeamEvent=true&".concat(filterParams.toString())).then(function (data) {
                return data !== null && data !== void 0 && data.length ? toEventCard(data[0]) : null;
              });
            }, {
              enabled: enabled
            });

          case 6:
            cachedFetch = _context5.sent;
            return _context5.abrupt("return", cachedFetch());

          case 8:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));

  return function fetchFeaturedEventData(_x3) {
    return _ref6.apply(this, arguments);
  };
}();
var createFeaturedEventQuery = function createFeaturedEventQuery(client) {
  return [["featuredEvent"], /*#__PURE__*/(0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee6() {
    return regenerator_default().wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            _context6.prev = 0;
            _context6.next = 3;
            return fetchFeaturedEventData(client);

          case 3:
            return _context6.abrupt("return", _context6.sent);

          case 6:
            _context6.prev = 6;
            _context6.t0 = _context6["catch"](0);
            console.error("Failed to load featuredEvent.\nUnderlying error: ".concat(_context6.t0));

          case 9:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6, null, [[0, 6]]);
  }))];
};
var useFeaturedEventQuery = (0,createQueryHook/* default */.Z)(createFeaturedEventQuery, contexts_staticSiteBackend/* useStaticSiteBackend */.gR, {
  staleTime: Infinity
});
;// CONCATENATED MODULE: ../../libs/api/routes/customerSuccessEvent/queries/filtersQuery.ts
/* provided dependency */ var filtersQuery_process = __webpack_require__(34406);






var fetchFilters = /*#__PURE__*/function () {
  var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(client) {
    var enabled, cachedFetch;
    return regenerator_default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            enabled = Boolean(filtersQuery_process.env.ENABLE_FS_CACHE);
            _context.next = 3;
            return (0,fsCache/* createFsCacheProxy */.c)(["eventFilters"], function () {
              return client.get("/content/contentTypes/event").then(function (data) {
                return groupFilters(data);
              });
            }, {
              enabled: enabled
            });

          case 3:
            cachedFetch = _context.sent;
            return _context.abrupt("return", cachedFetch());

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function fetchFilters(_x) {
    return _ref.apply(this, arguments);
  };
}();
var createFiltersQuery = function createFiltersQuery(client) {
  return [["events/filtersQuery"], function () {
    return fetchFilters(client);
  }];
};
var useFiltersQuery = (0,createQueryHook/* default */.Z)(createFiltersQuery, contexts_staticSiteBackend/* useStaticSiteBackend */.gR, {
  staleTime: Infinity
});
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(81333);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
;// CONCATENATED MODULE: ../../libs/api/routes/customerSuccessEvent/queries/useFilters.ts



function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}


var useFilters = function useFilters(entries) {
  var _useState = (0,react.useState)(_objectSpread({}, entries.reduce(function (acc, _ref) {
    var _ref2 = (0,slicedToArray/* default */.Z)(_ref, 1),
        key = _ref2[0];

    return _objectSpread(_objectSpread({}, acc), {}, (0,defineProperty/* default */.Z)({}, key, []));
  }, {}))),
      filtersState = _useState[0],
      setFiltersState = _useState[1];

  var createHandler = function createHandler(key, setState) {
    return function (selected) {
      return setState(function (prev) {
        return _objectSpread(_objectSpread({}, prev), {}, (0,defineProperty/* default */.Z)({}, key, selected));
      });
    };
  };

  var selectHandlers = entries.reduce(function (acc, _ref3) {
    var _ref4 = (0,slicedToArray/* default */.Z)(_ref3, 1),
        key = _ref4[0];

    return _objectSpread(_objectSpread({}, acc), {}, (0,defineProperty/* default */.Z)({}, key, createHandler(key, setFiltersState)));
  }, {});
  return {
    filtersState: filtersState,
    selectHandlers: selectHandlers
  };
};
// EXTERNAL MODULE: ../../node_modules/lodash/sortBy.js
var sortBy = __webpack_require__(829);
var sortBy_default = /*#__PURE__*/__webpack_require__.n(sortBy);
;// CONCATENATED MODULE: ../../libs/api/routes/customerSuccessEvent/queries/util.ts


var groupFilters = function groupFilters(types) {
  var groupedFilters = {};
  var filters = types.filter(function (type) {
    var _type$validations$, _type$validations$$in;

    return ((_type$validations$ = type.validations[0]) === null || _type$validations$ === void 0 ? void 0 : (_type$validations$$in = _type$validations$["in"]) === null || _type$validations$$in === void 0 ? void 0 : _type$validations$$in.length) > 0;
  });
  filters.forEach(function (filter) {
    var _validations$0$in;

    var name = filter.name,
        validations = filter.validations,
        id = filter.id;
    groupedFilters[id] = {
      title: name,
      items: sortBy_default()((_validations$0$in = validations[0]["in"]) === null || _validations$0$in === void 0 ? void 0 : _validations$0$in.sort().map(function (item) {
        return {
          title: item,
          id: "".concat(item.toLowerCase().replace(/\s/g, ""))
        };
      }), function (item) {
        return item.title.toLowerCase();
      })
    };
  });
  return groupedFilters;
};

var determineDateStr = function determineDateStr(start, end) {
  var startMonth = start.toLocaleString("en-US", {
    month: "short"
  });
  var startDay = start.getDate();
  var endMonth = end === null || end === void 0 ? void 0 : end.toLocaleString("en-US", {
    month: "short"
  });
  var endDay = end === null || end === void 0 ? void 0 : end.getDate();
  var startYear = start.getFullYear();
  var endYear = end === null || end === void 0 ? void 0 : end.getFullYear();
  var isSameYear = startYear === endYear;
  var isSameMonth = startMonth === endMonth;
  var isSameDay = startDay === endDay;
  var isSameMonthAndYear = isSameMonth && isSameYear;
  var isSameMonthDayAndYear = isSameMonth && isSameDay && isSameYear;

  if (isSameMonthDayAndYear) {
    return "".concat(startMonth, ". ").concat(startDay, ", ").concat(startYear);
  }

  if (isSameMonthAndYear) {
    return "".concat(startMonth, ". ").concat(startDay, "-").concat(endDay, ", ").concat(startYear);
  }

  return "".concat(startMonth, ". ").concat(startDay, " - ").concat(endMonth, ". ").concat(endDay, ", ").concat(endYear);
};

var toEventCard = function toEventCard(event) {
  var endDate = event.endDate,
      startDate = event.startDate,
      ctaText = event.ctaText,
      title = event.title,
      url = event.url,
      region = event.region,
      eventType = event.eventType,
      content = event.content,
      image = event.image;
  var eventStartDate = new Date(startDate);
  var eventEndDate = new Date(endDate || startDate);
  return {
    title: title,
    ctaText: ctaText,
    url: url,
    startDate: startDate,
    endDate: endDate || startDate,
    dateStr: determineDateStr(eventStartDate, eventEndDate),
    region: region,
    eventType: eventType,
    content: content,
    image: image
  };
};

var getTwoDigitMonth = function getTwoDigitMonth(month) {
  var adjustedMonth = month + 1;

  if (adjustedMonth < 10) {
    return "0".concat(adjustedMonth);
  }

  return "".concat(adjustedMonth);
};

var toMonthlyEvents = function toMonthlyEvents(events, todaysDate) {
  var groupedEvents = events.reduce(function (acc, event) {
    var eventStartDate = new Date(event.startDate);
    var eventEndDate = new Date(event.endDate || event.startDate);

    if (eventEndDate >= todaysDate) {
      var firstDayOfMonth = eventStartDate <= todaysDate ? "".concat(eventEndDate.getFullYear(), "-").concat(getTwoDigitMonth(eventEndDate.getMonth()), "-01") : "".concat(eventStartDate.getFullYear(), "-").concat(getTwoDigitMonth(eventStartDate.getMonth()), "-01");

      if (!acc[firstDayOfMonth]) {
        acc[firstDayOfMonth] = [];
      }

      acc[firstDayOfMonth].push(toEventCard(event));
    }

    return acc;
  }, {});
  return Object.entries(groupedEvents).map(function (_ref) {
    var _ref2 = (0,slicedToArray/* default */.Z)(_ref, 2),
        monthDate = _ref2[0],
        events = _ref2[1];

    events.sort(function (a, b) {
      return new Date(a.startDate).getTime() - new Date(b.startDate).getTime();
    });
    return {
      monthDate: monthDate,
      events: events
    };
  }).sort(function (a, b) {
    return new Date(a.monthDate).getTime() - new Date(b.monthDate).getTime();
  });
};
var getPastEvents = function getPastEvents(events, todaysDate) {
  var pastEvents = events.filter(function (event) {
    var eventEndDate = new Date(event.endDate || event.startDate);
    return eventEndDate < todaysDate;
  }).map(function (event) {
    return toEventCard(event);
  });
  return pastEvents;
};
;// CONCATENATED MODULE: ../../libs/api/routes/customerSuccessEvent/queries/index.ts




// EXTERNAL MODULE: ../../libs/next-shared/layout/index.ts
var layout = __webpack_require__(56052);
// EXTERNAL MODULE: ../../libs/matcha/components/Button/index.ts
var Button = __webpack_require__(33445);
// EXTERNAL MODULE: ../../libs/matcha/recipes/CopyText/index.ts + 2 modules
var CopyText = __webpack_require__(94136);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Hero/index.tsx + 2 modules
var recipes_Hero = __webpack_require__(84629);
// EXTERNAL MODULE: ../../libs/utils/getAbsoluteUrl/getAbsoluteUrl.ts
var getAbsoluteUrl = __webpack_require__(43848);
// EXTERNAL MODULE: ../../libs/contexts/page.ts
var page = __webpack_require__(17782);
// EXTERNAL MODULE: ../../libs/matcha/components/Icons/Brandbook.ts + 92 modules
var Brandbook = __webpack_require__(79550);
// EXTERNAL MODULE: ../../libs/matcha/components/Badge/index.ts + 2 modules
var Badge = __webpack_require__(16154);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Card/index.ts + 31 modules
var recipes_Card = __webpack_require__(74881);
// EXTERNAL MODULE: ../../libs/matcha/recipes/RichText/index.ts
var RichText = __webpack_require__(47756);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ./src/views/CustomerSuccessEvents/components/Hero/FeaturedCard.tsx









var FeaturedCard = function FeaturedCard(_ref) {
  var data = _ref.data;
  var title = data.title,
      ctaText = data.ctaText,
      url = data.url,
      dateStr = data.dateStr,
      eventType = data.eventType,
      region = data.region,
      content = data.content,
      image = data.image;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledCardBase, {
    href: url,
    children: [image && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(recipes_Card/* Image */.Ee, {
      alt: "",
      src: image === null || image === void 0 ? void 0 : image.fields.file.url,
      variant: "fill"
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(recipes_Card/* Body */.uT, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(recipes_Card/* Accessories */.v8, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(recipes_Card/* AccessoriesRow */.OW, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Brandbook/* CalendarIcon */.Qu, {
            size: "small"
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(recipes_Card/* Label */.__, {
            children: dateStr
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(recipes_Card/* Label */.__, {
            children: "\u2022"
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Brandbook/* MapPinIcon */.tE, {
            size: "nav"
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(recipes_Card/* Label */.__, {
            children: region
          })]
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(recipes_Card/* AccessoriesRow */.OW, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Badge/* default */.Z, {
            variant: "filledGreen",
            children: "Featured"
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Badge/* default */.Z, {
            variant: "outlined",
            children: eventType
          })]
        })]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(recipes_Card/* Copy */.CK, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(recipes_Card/* Headline */.s0, {
          tag: "h2",
          children: title
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(recipes_Card/* Description */.dk, {
          tag: "div",
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RichText/* default */.ZP, {
            data: content
          })
        })]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(recipes_Card/* Action */.aU, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
          color: "primary",
          size: "large",
          variant: "filled",
          children: ctaText
        })
      })]
    })]
  });
};

var StyledCardBase = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(recipes_Card/* default */.ZP,  true ? {
  target: "ekck3lc0"
} : 0)(function (_ref2) {
  var theme = _ref2.theme;
  return theme.breakpoints.down("md");
}, "{text-align:left;}" + ( true ? "" : 0));

/* harmony default export */ var Hero_FeaturedCard = (FeaturedCard);
// EXTERNAL MODULE: ./src/views/CustomerSuccessEvents/components/Hero/assets/Hero@2x.png
var Hero_2x = __webpack_require__(91395);
var Hero_2x_default = /*#__PURE__*/__webpack_require__.n(Hero_2x);
// EXTERNAL MODULE: ./src/views/CustomerSuccessEvents/components/Hero/assets/Hero.webp
var Hero = __webpack_require__(76157);
var Hero_default = /*#__PURE__*/__webpack_require__.n(Hero);
// EXTERNAL MODULE: ./src/views/CustomerSuccessEvents/components/Hero/assets/Hero@2x.webp
var assets_Hero_2x = __webpack_require__(97504);
var assets_Hero_2x_default = /*#__PURE__*/__webpack_require__.n(assets_Hero_2x);
;// CONCATENATED MODULE: ./src/views/CustomerSuccessEvents/components/Hero/HeroImage.tsx


function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }







var SIZES = "(max-width: 600px) 540px, 1080px";

var HeroImage = function HeroImage() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Wrapper, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledPicture, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("source", {
        width: "540",
        height: "540",
        type: "image/webp",
        srcSet: "".concat((Hero_default()), " 540w, ").concat((assets_Hero_2x_default()), " 1080w"),
        sizes: SIZES
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(recipes_Hero/* Image */.Ee, {
        width: "540",
        height: "540",
        src: (Hero_2x_default()),
        sizes: SIZES,
        alt: "Events Image"
      })]
    })
  });
};

var Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1axv7r61"
} : 0)( true ? {
  name: "f73z5m",
  styles: "width:100%;height:0;padding-top:100%;position:relative"
} : 0);

var StyledPicture = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("picture",  true ? {
  target: "e1axv7r60"
} : 0)( true ? {
  name: "1r0zrug",
  styles: "position:absolute;top:0;left:0;width:100%"
} : 0);

/* harmony default export */ var Hero_HeroImage = (HeroImage);
;// CONCATENATED MODULE: ./src/views/CustomerSuccessEvents/components/Hero/Hero.tsx










var copy = {
  heading: "Customer Success Events",
  description: "Customer-focused, interactive, and educational events by Segment practitioners, for Segment practitioners."
};
var pastWebinarsLink = {
  text: "See past webinars",
  href: "#past-webinars"
};

var Hero_Hero = function Hero(_ref) {
  var data = _ref.data;
  var pageConfig = (0,page/* usePageConfig */.Gm)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Hero_Wrapper, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(recipes_Hero/* default */.ZP, {
      variant: "2Col",
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledHeroRecipeCopy, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
          variant: "h1",
          tag: "h1",
          children: copy.heading
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
          variant: "pExtraLarge",
          tag: "p",
          children: copy.description
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
          size: "large",
          variant: "outlined",
          tag: "a",
          color: "primary",
          href: (0,getAbsoluteUrl/* default */.Z)(pastWebinarsLink.href, pageConfig),
          children: pastWebinarsLink.text
        })]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(recipes_Hero/* Contents */.AU, {
        children: data ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Hero_FeaturedCard, {
          data: data
        }) : (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Hero_HeroImage, {})
      })]
    })
  });
};

var StyledHeroRecipeCopy = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(recipes_Hero/* Copy */.CK,  true ? {
  target: "eddffpo1"
} : 0)(function (_ref2) {
  var theme = _ref2.theme;
  return theme.breakpoints.down("md");
}, "{text-align:left;}" + ( true ? "" : 0));

var Hero_Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("header",  true ? {
  target: "eddffpo0"
} : 0)("background-color:", function (_ref3) {
  var theme = _ref3.theme;
  return theme.palette.twilio.green[10];
}, ";" + ( true ? "" : 0));

/* harmony default export */ var components_Hero_Hero = (Hero_Hero);
// EXTERNAL MODULE: ../../libs/matcha/components/ColumnTrack/index.ts + 2 modules
var ColumnTrack = __webpack_require__(85735);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Section/index.ts + 2 modules
var Section = __webpack_require__(88392);
// EXTERNAL MODULE: ../../libs/matcha/components/Select/index.ts + 9 modules
var Select = __webpack_require__(44502);
// EXTERNAL MODULE: ../../libs/matcha/components/Select/useSelect/index.ts + 3 modules
var useSelect = __webpack_require__(27431);
// EXTERNAL MODULE: ../../libs/matcha/components/Input/index.ts + 2 modules
var Input = __webpack_require__(94261);
// EXTERNAL MODULE: ../../libs/matcha/components/Icons/Common.ts + 14 modules
var Common = __webpack_require__(6580);
;// CONCATENATED MODULE: ./src/views/CustomerSuccessEvents/components/Filter/Filter.tsx



function Filter_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Filter_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Filter_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Filter_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }










var FilterSelect = function FilterSelect(_ref) {
  var options = _ref.options,
      id = _ref.id,
      onSelect = _ref.onSelect,
      placeholder = _ref.placeholder,
      disabled = _ref.disabled;
  var theme = (0,emotion_element_6a883da9_browser_esm.u)();
  var appearance = (0,AppearanceContext/* useAppearance */.M)();
  var iconColor = appearance === "dark" ? theme.palette.neutrals.white[100] : theme.palette.twilio.gray[80];

  var _useSelect = (0,useSelect/* default */.Z)({
    options: options,
    id: id,
    onSelect: onSelect,
    config: {
      multiselect: true,
      mobileConfirmationBehaviour: true
    }
  }),
      state = _useSelect.state,
      getControlProps = _useSelect.getControlProps,
      filteredOptions = _useSelect.filteredOptions,
      getSelectProps = _useSelect.getSelectProps;

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Filter_Wrapper, {
    appearance: appearance,
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Input/* default */.Z, Filter_objectSpread(Filter_objectSpread({
      name: id,
      type: "search",
      resetable: state.filterValue !== "",
      clearIcon: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Select/* ClearSelect */.kr, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Common/* ClearIcon */.Rk, {
          size: "small",
          color: iconColor
        })
      }),
      rightSecondIcon: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Common/* ChevronDownIcon */.v4, {
        color: iconColor
      })
    }, getControlProps({
      placeholder: placeholder,
      counter: true
    })), {}, {
      "aria-label": placeholder,
      disabled: disabled
    })), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Select/* default */.ZP, Filter_objectSpread({
      id: "select-base-".concat(id),
      name: "select-base-".concat(id),
      options: options,
      filteredOptions: filteredOptions,
      displayMode: state.displayMode,
      open: state.open,
      listItemComponent: Select/* MenuItemWithCheckbox */.N1
    }, getSelectProps()))]
  });
};

/* harmony default export */ var Filter = (FilterSelect);

var Filter_Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e141lsap0"
} : 0)("background:", function (_ref2) {
  var theme = _ref2.theme,
      appearance = _ref2.appearance;
  return appearance === "dark" && theme.palette.brand.darkAcai[700];
}, ";z-index:1;" + ( true ? "" : 0));
;// CONCATENATED MODULE: ./src/views/CustomerSuccessEvents/components/Filters/Filters.tsx







var toOptionProps = function toOptionProps(filter) {
  var title = filter.title;
  return {
    value: title,
    text: title
  };
};

var Filters = function Filters(_ref) {
  var _ref$onFilterChange = _ref.onFilterChange,
      onFilterChange = _ref$onFilterChange === void 0 ? function () {
    return null;
  } : _ref$onFilterChange,
      filters = _ref.filters,
      disabled = _ref.disabled;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledSectionBase, {
    variant: "noCopy",
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Contents */.AU, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledColumnTrack, {
        gap: "small",
        columns: 1,
        overrides: {
          lg: filters === null || filters === void 0 ? void 0 : filters.length
        },
        children: filters === null || filters === void 0 ? void 0 : filters.map(function (_ref2) {
          var _ref3 = (0,slicedToArray/* default */.Z)(_ref2, 2),
              key = _ref3[0],
              filter = _ref3[1];

          return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Filter, {
            options: filter.items.map(toOptionProps),
            id: key,
            onSelect: function onSelect(selectedOptions) {
              return onFilterChange(key, selectedOptions);
            },
            placeholder: filter.title,
            disabled: disabled
          }, key);
        })
      })
    })
  });
};

var StyledSectionBase = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* default */.ZP,  true ? {
  target: "etbglqh1"
} : 0)("overflow:visible;", Section/* Wrapper */.im, "{justify-content:unset;padding-top:24px;padding-bottom:40px;row-gap:24px;", function (_ref4) {
  var theme = _ref4.theme;
  return theme.breakpoints.up("lg");
}, "{padding-top:40px;}}" + ( true ? "" : 0));

var StyledColumnTrack = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(ColumnTrack/* default */.Z,  true ? {
  target: "etbglqh0"
} : 0)("row-gap:8px;margin:auto;margin-bottom:8px;", function (_ref5) {
  var theme = _ref5.theme;
  return theme.breakpoints.up("lg");
}, "{max-width:536px;}" + ( true ? "" : 0));

/* harmony default export */ var Filters_Filters = (Filters);
// EXTERNAL MODULE: ../../libs/matcha/components/ButtonText/index.ts
var ButtonText = __webpack_require__(74870);
;// CONCATENATED MODULE: ./src/views/CustomerSuccessEvents/components/Card/Card.tsx










var Card = function Card(_ref) {
  var title = _ref.title,
      content = _ref.content,
      ctaText = _ref.ctaText,
      url = _ref.url,
      dateStr = _ref.dateStr,
      eventType = _ref.eventType,
      region = _ref.region;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(recipes_Card/* default */.ZP, {
    href: url,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(recipes_Card/* Body */.uT, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(recipes_Card/* Accessories */.v8, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(recipes_Card/* AccessoriesRow */.OW, {
          children: [dateStr && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Brandbook/* CalendarIcon */.Qu, {
              size: "small"
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(recipes_Card/* Label */.__, {
              children: dateStr
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(recipes_Card/* Label */.__, {
              children: "\u2022"
            })]
          }), region && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Brandbook/* MapPinIcon */.tE, {
              size: "nav"
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(recipes_Card/* Label */.__, {
              children: region
            })]
          })]
        }), eventType && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(recipes_Card/* AccessoriesRow */.OW, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Badge/* default */.Z, {
            variant: "outlined",
            children: eventType
          })
        })]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(recipes_Card/* Copy */.CK, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(recipes_Card/* Headline */.s0, {
          tag: "h2",
          children: title
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(recipes_Card/* Description */.dk, {
          tag: "div",
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RichText/* default */.ZP, {
            data: content
          })
        })]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(recipes_Card/* Action */.aU, {
        alignment: "left",
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ButtonText/* default */.Z, {
          iconEnd: Common/* ChevronRightIcon */.XC,
          children: ctaText
        })
      })]
    })
  });
};

/* harmony default export */ var Card_Card = (Card);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(82269);
;// CONCATENATED MODULE: ./src/views/CustomerSuccessEvents/components/CardsGroup/CardsGroup.tsx


var _excluded = ["children"];

function CardsGroup_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function CardsGroup_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? CardsGroup_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : CardsGroup_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




var CardsGroup = function CardsGroup(_ref) {
  var children = _ref.children,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ColumnTrack/* default */.Z, CardsGroup_objectSpread(CardsGroup_objectSpread({
    columns: 1,
    overrides: {
      lg: 2
    }
  }, rest), {}, {
    children: children
  }));
};

/* harmony default export */ var CardsGroup_CardsGroup = (CardsGroup);
;// CONCATENATED MODULE: ./src/views/CustomerSuccessEvents/components/CardsSection/CardsSection.tsx



var CardsSection_excluded = ["title", "isLoading", "children"];

function CardsSection_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function CardsSection_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? CardsSection_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : CardsSection_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function CardsSection_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }







var CardsSection = function CardsSection(_ref2) {
  var title = _ref2.title,
      _ref2$isLoading = _ref2.isLoading,
      isLoading = _ref2$isLoading === void 0 ? false : _ref2$isLoading,
      children = _ref2.children,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref2, CardsSection_excluded);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CardsSection_StyledSectionBase, CardsSection_objectSpread(CardsSection_objectSpread({
    variant: "noCopy"
  }, rest), {}, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Section/* Contents */.AU, {
      children: [title && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledCopyTextBase, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Overline */.Lh, {
          children: title
        })
      }), children]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LoadingOverlay, {
      "data-testid": "loading-overlay",
      "aria-busy": isLoading,
      isLoading: isLoading
    })]
  }));
};

var StyledCopyTextBase = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(CopyText/* default */.ZP,  true ? {
  target: "ebpsivr2"
} : 0)( true ? {
  name: "qkomnt",
  styles: "margin-bottom:40px"
} : 0);

var CardsSection_StyledSectionBase = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* default */.ZP,  true ? {
  target: "ebpsivr1"
} : 0)("position:relative;", Section/* Wrapper */.im, "{padding-top:40px;}" + ( true ? "" : 0));

var _ref =  true ? {
  name: "o9ww1u",
  styles: "opacity:0.5"
} : 0;

var LoadingOverlay = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ebpsivr0"
} : 0)("opacity:0;background-color:", function (_ref3) {
  var theme = _ref3.theme;
  return theme.palette.neutrals.white[100];
}, ";position:absolute;top:0;left:0;bottom:0;right:0;width:100%;transition:opacity ease-in-out 0.3s;z-index:1;pointer-events:none;", function (_ref4) {
  var isLoading = _ref4.isLoading;
  return isLoading && _ref;
}, ";" + ( true ? "" : 0));

/* harmony default export */ var CardsSection_CardsSection = (CardsSection);
;// CONCATENATED MODULE: ./src/views/CustomerSuccessEvents/components/EventsGrid/EventsGrid.tsx





var EventsGrid = function EventsGrid(_ref) {
  var events = _ref.events,
      isLoading = _ref.isLoading,
      title = _ref.title;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardsSection_CardsSection, {
    isLoading: isLoading,
    title: title,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardsGroup_CardsGroup, {
      "data-testid": "cards-grid",
      "aria-live": "polite",
      "aria-busy": isLoading,
      children: events.map(function (_ref2) {
        var title = _ref2.title,
            ctaText = _ref2.ctaText,
            url = _ref2.url,
            dateStr = _ref2.dateStr,
            eventType = _ref2.eventType,
            region = _ref2.region,
            content = _ref2.content;
        return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Card_Card, {
          title: title,
          ctaText: ctaText,
          url: url,
          dateStr: dateStr,
          eventType: eventType,
          region: region,
          content: content
        }, title);
      })
    })
  });
};

/* harmony default export */ var EventsGrid_EventsGrid = (EventsGrid);
// EXTERNAL MODULE: ../../libs/matcha/components/Divider/index.ts + 1 modules
var Divider = __webpack_require__(76305);
;// CONCATENATED MODULE: ./src/views/CustomerSuccessEvents/components/EventDivider/EventDivider.tsx





var EventDivider = function EventDivider() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EventDivider_StyledSectionBase, {
    variant: "noCopy",
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Contents */.AU, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Divider/* default */.Z, {})
    })
  });
};

var EventDivider_StyledSectionBase = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* default */.ZP,  true ? {
  target: "e1freaml0"
} : 0)(Section/* Wrapper */.im, "{padding-top:0;padding-bottom:0;}" + ( true ? "" : 0));

/* harmony default export */ var EventDivider_EventDivider = (EventDivider);
;// CONCATENATED MODULE: ./src/views/CustomerSuccessEvents/components/EventResults/NoResults.tsx


function NoResults_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }









var NoResults_link = {
  text: "past webinars.",
  url: "#past-webinars"
};

var NoResults = function NoResults(_ref) {
  var heading = _ref.heading,
      description = _ref.description;
  var pageConfig = (0,page/* usePageConfig */.Gm)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* default */.ZP, {
    variant: "noCopy",
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Section/* Contents */.AU, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
        variant: "h4",
        tag: "p",
        children: heading
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* Description */.dk, {
        variant: "pMedium",
        tag: "p",
        children: [description, (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RichText/* Hyperlink */.nW, {
          size: "small",
          tag: "a",
          href: (0,getAbsoluteUrl/* default */.Z)(NoResults_link.url, pageConfig),
          children: NoResults_link.text
        })]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DividerWrapper, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Divider/* default */.Z, {})
      })]
    })
  });
};

var DividerWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1f6k5fx0"
} : 0)( true ? {
  name: "1lw3ul3",
  styles: "margin-top:40px"
} : 0);

/* harmony default export */ var EventResults_NoResults = (NoResults);
;// CONCATENATED MODULE: ./src/views/CustomerSuccessEvents/components/EventResults/EventResults.tsx






var noUpComingEventsText = {
  heading: "We don\u2019t have any upcoming events.",
  description: "Try checking back or use the form below to stay informed about new events. You can also see our "
};
var noMatchingEventsText = {
  heading: "Sorry, we couldn't find a match for that.",
  description: "Try adjusting the filters above to expand the results. You can also see our "
};

var EventResults = function EventResults(_ref) {
  var initialEvents = _ref.initialEvents,
      events = _ref.events,
      isLoading = _ref.isLoading;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(EventResults_Wrapper, {
    children: [(initialEvents === null || initialEvents === void 0 ? void 0 : initialEvents.length) === 0 && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EventResults_NoResults, {
      heading: noUpComingEventsText.heading,
      description: noUpComingEventsText.description
    }), (events === null || events === void 0 ? void 0 : events.length) === 0 && (initialEvents === null || initialEvents === void 0 ? void 0 : initialEvents.length) !== 0 && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EventResults_NoResults, {
      heading: noMatchingEventsText.heading,
      description: noMatchingEventsText.description
    }), events === null || events === void 0 ? void 0 : events.map(function (_ref2) {
      var events = _ref2.events,
          monthDate = _ref2.monthDate;
      return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(GridWrapper, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EventsGrid_EventsGrid, {
          events: events,
          isLoading: isLoading,
          title: new Date("".concat(monthDate, "T00:00")).toLocaleString("en-us", {
            month: "long"
          })
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EventDivider_EventDivider, {})]
      }, monthDate);
    })]
  });
};

var EventResults_Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "el45jg51"
} : 0)( true ? "" : 0);

var GridWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "el45jg50"
} : 0)( true ? "" : 0);

/* harmony default export */ var EventResults_EventResults = (EventResults);
// EXTERNAL MODULE: ../../libs/templates/Forms/EmailCaptureForm/index.ts + 3 modules
var EmailCaptureForm = __webpack_require__(41948);
// EXTERNAL MODULE: ../../node_modules/@contentful/rich-text-types/dist/index.js
var dist = __webpack_require__(82562);
;// CONCATENATED MODULE: ./src/views/CustomerSuccessEvents/components/StayInTheKnow/disclaimer.ts

var disclaimer = {
  data: {},
  content: [{
    data: {},
    content: [{
      data: {},
      marks: [],
      value: "We\u2019ll send you notifications of Segment Customer Success events. We use your information according to our ",
      nodeType: "text"
    }, {
      data: {
        uri: "https://www.twilio.com/legal/privacy/"
      },
      content: [{
        data: {},
        marks: [],
        value: "privacy policy",
        nodeType: "text"
      }],
      nodeType: dist.INLINES.HYPERLINK
    }, {
      data: {},
      marks: [],
      value: ". You can update your preferences at any time.",
      nodeType: "text"
    }],
    nodeType: dist.BLOCKS.PARAGRAPH
  }],
  nodeType: dist.BLOCKS.DOCUMENT
};
;// CONCATENATED MODULE: ./src/views/CustomerSuccessEvents/components/StayInTheKnow/StayInTheKnow.tsx


function StayInTheKnow_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }







var copyText = {
  title: "Stay in the know",
  line1: "Want to be the first to know about Segment events?",
  line2: "Submit your email below, and we'll add you to our invite list."
};
var emailCaptureOverrides = {
  buttonText: "Keep me updated",
  buttonUrl: "#past-webinars",
  successButtonText: "See Past Webinars",
  successMessageHeading: "You're on the list!",
  successMessageDescription: "You are now registered for Segment event updates. Keep an eye on your inbox, we'll see you soon."
};

var StayInTheKnow = function StayInTheKnow() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StayInTheKnow_StyledSectionBase, {
    variant: "centered",
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* default */.ZP, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Section/* Copy */.CK, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
          tag: "h2",
          children: copyText.title
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* Description */.dk, {
          tag: "p",
          variant: "pLarge",
          children: [copyText.line1, (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("br", {}), " ", copyText.line2]
        })]
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledSectionContents, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EmailCaptureForm/* default */.Z, {
        buttonText: emailCaptureOverrides.buttonText,
        successButtonText: emailCaptureOverrides.successButtonText,
        successMessageHeading: emailCaptureOverrides.successMessageHeading,
        successMessageDescription: emailCaptureOverrides.successMessageDescription,
        buttonUrl: emailCaptureOverrides.buttonUrl,
        customFormIdentifier: "cs-events-email",
        customTrackingType: "cs-events-email",
        customDisclaimer: disclaimer
      })
    })]
  });
};

var StayInTheKnow_StyledSectionBase = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* default */.ZP,  true ? {
  target: "ewitym51"
} : 0)(Section/* Wrapper */.im, "{row-gap:32px;}" + ( true ? "" : 0));

var StyledSectionContents = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* Contents */.AU,  true ? {
  target: "ewitym50"
} : 0)( true ? {
  name: "ztiht2",
  styles: "max-width:417px"
} : 0);

/* harmony default export */ var StayInTheKnow_StayInTheKnow = (StayInTheKnow);
// EXTERNAL MODULE: ../../libs/matcha/components/Typography/index.ts
var Typography = __webpack_require__(89533);
;// CONCATENATED MODULE: ./src/views/CustomerSuccessEvents/components/PastWebinars/PastWebinars.tsx


function PastWebinars_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }










var PastWebinars_copy = {
  heading: "Past Webinar Recordings"
};

var PastWebinars = function PastWebinars(_ref) {
  var data = _ref.data;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Section/* default */.ZP, {
    variant: "centered",
    id: "past-webinars",
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Copy */.CK, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Typography/* default */.Z, {
        variant: "h2",
        tag: "h2",
        children: PastWebinars_copy.heading
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Contents */.AU, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PastWebinars_StyledColumnTrack, {
        columns: 1,
        overrides: {
          lg: 3
        },
        children: data.map(function (_ref2, key) {
          var eventType = _ref2.eventType,
              title = _ref2.title,
              content = _ref2.content,
              ctaText = _ref2.ctaText,
              url = _ref2.url,
              image = _ref2.image;
          return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(recipes_Card/* default */.ZP, {
            href: url,
            children: [image && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(recipes_Card/* Image */.Ee, {
              alt: "",
              src: image === null || image === void 0 ? void 0 : image.fields.file.url,
              variant: "fill"
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(recipes_Card/* Body */.uT, {
              children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(recipes_Card/* Accessories */.v8, {
                children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(recipes_Card/* AccessoriesRow */.OW, {
                  children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(recipes_Card/* Label */.__, {
                    children: eventType
                  })
                })
              }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(recipes_Card/* Copy */.CK, {
                children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(recipes_Card/* Headline */.s0, {
                  tag: "h3",
                  children: title
                }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(recipes_Card/* Description */.dk, {
                  tag: "div",
                  children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RichText/* default */.ZP, {
                    data: content
                  })
                })]
              }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(recipes_Card/* Action */.aU, {
                alignment: "left",
                children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ButtonText/* default */.Z, {
                  iconEnd: Common/* ChevronRightIcon */.XC,
                  children: ctaText
                })
              })]
            })]
          }, key);
        })
      })
    })]
  });
};

var PastWebinars_StyledColumnTrack = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(ColumnTrack/* default */.Z,  true ? {
  target: "epjtgyh0"
} : 0)( true ? {
  name: "xw24us",
  styles: "max-width:1120px;margin:0 auto"
} : 0);

/* harmony default export */ var PastWebinars_PastWebinars = (PastWebinars);
// EXTERNAL MODULE: ./src/views/CustomerSuccessEvents/assets/OgEvents.jpg
var OgEvents = __webpack_require__(44425);
var OgEvents_default = /*#__PURE__*/__webpack_require__.n(OgEvents);
;// CONCATENATED MODULE: ./src/views/CustomerSuccessEvents/CustomerSuccessEvents.tsx



















var CustomerSuccessEventsView = function CustomerSuccessEventsView() {
  var theme = (0,emotion_element_6a883da9_browser_esm.u)();
  var layoutData = (0,react.useMemo)(function () {
    return {
      title: "Customer Success Events | Twilio Segment",
      description: "Learn about how to maximize the power of Twilio Segment with events from the Customer Success team.",
      og: (OgEvents_default()),
      backgroundColor: theme.palette.neutrals.white[100]
    };
  }, [theme]);

  var _useFiltersQuery = useFiltersQuery({
    args: []
  }),
      filters = _useFiltersQuery.data;

  var _useFeaturedEventQuer = useFeaturedEventQuery({
    args: []
  }),
      featuredEvent = _useFeaturedEventQuer.data;

  var groupedFilterEntries = Object.entries(filters || {});

  var _useFilters = useFilters(groupedFilterEntries),
      filtersState = _useFilters.filtersState,
      selectHandlers = _useFilters.selectHandlers; // eslint-disable-next-line react-hooks/exhaustive-deps


  var initialFilters = (0,react.useMemo)(function () {
    return filtersState;
  }, []);

  var _useEventsQuery = useEventsQuery({
    args: [{
      filters: initialFilters
    }]
  }),
      initialEvents = _useEventsQuery.data;

  var _useEventsQuery2 = useEventsQuery({
    args: [{
      filters: filtersState
    }]
  }),
      filteredData = _useEventsQuery2.data,
      isFetching = _useEventsQuery2.isFetching;

  var _usePastEventsQuery = usePastEventsQuery({
    args: []
  }),
      pastEventsData = _usePastEventsQuery.data;

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AppearanceContext/* AppearanceProvider */.x, {
    appearance: "twilioLight",
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(layout/* default */.Z, {
      pageTitle: layoutData.title,
      pageDescription: layoutData.description,
      pageOG: layoutData.og,
      bodyBackground: layoutData.backgroundColor,
      pageRobotsDirective: "noindex",
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Navigation/* default */.Z, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_Hero_Hero, {
        data: featuredEvent || null
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Main, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Filters_Filters, {
          filters: groupedFilterEntries,
          onFilterChange: function onFilterChange(filterId, selectedOptions) {
            return selectHandlers[filterId](selectedOptions);
          },
          disabled: (initialEvents === null || initialEvents === void 0 ? void 0 : initialEvents.length) === 0
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EventResults_EventResults, {
          initialEvents: initialEvents,
          events: filteredData,
          isLoading: isFetching
        }), pastEventsData ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PastWebinars_PastWebinars, {
          data: pastEventsData
        }) : null, (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StayInTheKnow_StayInTheKnow, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LogoWrapper, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LogoTiles/* default */.Z, {})
        })]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Footer/* default */.Z, {})]
    })
  });
};

var Main = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("main",  true ? {
  target: "elgfj4f1"
} : 0)("background-color:", function (_ref) {
  var theme = _ref.theme;
  return theme.palette.neutrals.white[100];
}, ";" + ( true ? "" : 0));

var LogoWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "elgfj4f0"
} : 0)("background:", function (_ref2) {
  var theme = _ref2.theme;
  return theme.palette.twilio.gray[10];
}, ";", LogoTiles_views/* TilesGridWrapper */.W, "{max-width:100%;}" + ( true ? "" : 0));

/* harmony default export */ var CustomerSuccessEvents = (CustomerSuccessEventsView);
;// CONCATENATED MODULE: ./src/pages/events/customer-success.tsx





var EventsCustomerSuccess = function EventsCustomerSuccess() {
  var staticSiteBackend = (0,react.useMemo)(function () {
    return (0,contexts_staticSiteBackend/* createStaticSiteBackend */.I4)();
  }, []);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(contexts_staticSiteBackend/* StaticSiteBackendProvider */.D1, {
    value: staticSiteBackend,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CustomerSuccessEvents, {})
  });
};

var __N_SSG = true;
/* harmony default export */ var customer_success = (EventsCustomerSuccess);

/***/ }),

/***/ 86708:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D1": function() { return /* binding */ StaticSiteBackendProvider; },
/* harmony export */   "I4": function() { return /* binding */ createStaticSiteBackend; },
/* harmony export */   "gR": function() { return /* binding */ useStaticSiteBackend; }
/* harmony export */ });
/* unused harmony export StaticSiteBackendContext */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _segment_api_staticSiteBackend_client__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(39896);


var StaticSiteBackendContext = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(null);
var StaticSiteBackendProvider = StaticSiteBackendContext.Provider;
var useStaticSiteBackend = function useStaticSiteBackend() {
  var staticSiteBackend = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(StaticSiteBackendContext);

  if (!staticSiteBackend) {
    throw new Error("Static site backend isn't available. Please set it via StaticSiteBackendProvider component.");
  }

  return staticSiteBackend;
}; // Helper method to simplify importing

var createStaticSiteBackend = function createStaticSiteBackend() {
  return (0,_segment_api_staticSiteBackend_client__WEBPACK_IMPORTED_MODULE_1__/* .createClient */ .e)();
};

/***/ }),

/***/ 56052:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* reexport safe */ _Layout__WEBPACK_IMPORTED_MODULE_0__.Z; }
/* harmony export */ });
/* harmony import */ var _Layout__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6372);


/***/ }),

/***/ 34810:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Footer_Footer; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(82269);
// EXTERNAL MODULE: ../../node_modules/next/link.js
var next_link = __webpack_require__(39097);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ../../libs/matcha/foundations/AppearanceContext/index.ts + 1 modules
var AppearanceContext = __webpack_require__(9381);
// EXTERNAL MODULE: ../../libs/matcha/components/Button/index.ts
var Button = __webpack_require__(33445);
// EXTERNAL MODULE: ../../libs/matcha/components/SegmentLogo/index.ts + 2 modules
var SegmentLogo = __webpack_require__(84672);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Footer/index.ts + 4 modules
var recipes_Footer = __webpack_require__(80653);
// EXTERNAL MODULE: ../../libs/utils/getAbsoluteUrl/getAbsoluteUrl.ts
var getAbsoluteUrl = __webpack_require__(43848);
// EXTERNAL MODULE: ../../libs/contexts/page.ts
var page = __webpack_require__(17782);
// EXTERNAL MODULE: ../../libs/templates/Footer/data.ts
var Footer_data = __webpack_require__(52661);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
;// CONCATENATED MODULE: ../../libs/templates/Footer/Footer.views.tsx


function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

var BrandLink = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("span",  true ? {
  target: "ed41syo0"
} : 0)( true ? {
  name: "vetbs0",
  styles: "display:grid"
} : 0);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/templates/Footer/Footer.tsx


var _excluded = ["appearance"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}












var Footer = function Footer(_ref) {
  var appearance = _ref.appearance,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  var pageConfig = (0,page/* usePageConfig */.Gm)();
  var footerAppearance = (0,AppearanceContext/* useAppearance */.M)(appearance);
  var ctaText = "See how it works";
  var data = (0,Footer_data/* default */.Z)(pageConfig);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(recipes_Footer/* default */.Z, _objectSpread({
    bottomLinks: data.bottomLinks,
    mainLinks: data.mainLinks,
    copyright: data.copyright,
    logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AppearanceContext/* AppearanceProvider */.x, {
      appearance: footerAppearance,
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
        href: (0,getAbsoluteUrl/* default */.Z)("/", pageConfig),
        passHref: true,
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BrandLink, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SegmentLogo/* default */.Z, {
            alt: "Twilio, Inc.",
            footer: true
          })
        })
      })
    }),
    cta: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
      color: "primary",
      variant: "filled",
      size: "large",
      href: (0,getAbsoluteUrl/* default */.Z)("/demo/", pageConfig),
      children: ctaText
    }),
    appearance: appearance
  }, props));
};

/* harmony default export */ var Footer_Footer = (Footer);

/***/ }),

/***/ 52661:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(43848);


var getData = function getData(pageConfig) {
  return {
    logo: {
      src: "/images/SegmentLogoWhite.png",
      srcSet: "/images/SegmentLogoWhite@2x.png 2x",
      alt: "Twilio, Inc.",
      width: 300,
      height: 65
    },
    bottomLinks: [{
      url: "https://www.twilio.com/legal/privacy/",
      title: "Privacy policy"
    }, {
      url: "https://www.twilio.com/legal/tos/",
      title: "Terms of Service"
    }],
    mainLinks: [{
      title: "Products",
      links: [{
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/product/connections/", pageConfig),
        title: "Connections"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/product/protocols/", pageConfig),
        title: "Protocols"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/product/unify/", pageConfig),
        title: "Unify"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/product/twilio-engage/", pageConfig),
        title: "Twilio Engage"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/customer-data-platform/", pageConfig),
        title: "Customer Data Platform",
        rel: "nofollow"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/catalog/", pageConfig),
        title: "Integrations Catalog"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/pricing/", pageConfig),
        title: "Pricing"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/security/", pageConfig),
        title: "Security"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/product/gdpr/", pageConfig),
        title: "GDPR"
      }]
    }, {
      title: "For Developers",
      links: [{
        url: "https://segment.com/docs/",
        title: "Documentation"
      }, {
        url: "https://docs.segmentapis.com/",
        title: "Segment API"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/partners/developer-portal/", pageConfig),
        title: "Build on Segment"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/opensource/", pageConfig),
        title: "Open Source"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/engineering/", pageConfig),
        title: "Engineering Team"
      }]
    }, {
      title: "Company",
      links: [{
        url: "https://www.twilio.com/company/jobs/",
        title: "Careers"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("https://segment.com/blog/", pageConfig),
        title: "Blog"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("https://segment.com/newsroom/", pageConfig),
        title: "Press"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/events/", pageConfig),
        title: "Events"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/good-data-better-marketing/", pageConfig),
        title: "Podcast"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/growth-center/", pageConfig),
        title: "Growth Center"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/data-hub/", pageConfig),
        title: "Data Hub"
      }]
    }, {
      title: "Support",
      links: [{
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/help/", pageConfig),
        title: "Help Center"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/contact/", pageConfig),
        title: "Contact us"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/resources/", pageConfig),
        title: "Resources"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/recipes/", pageConfig),
        title: "Recipes"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/services/", pageConfig),
        title: "Professional Services"
      }, {
        url: "https://segment.com/security/bulletins/",
        title: "Security Bulletins"
      }, {
        url: "https://segment.com/docs/",
        title: "Documentation"
      }, {
        url: "https://segment.com/release-notes/",
        title: "Release Notes"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/partners/", pageConfig),
        title: "Become a Partner"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/resources/cdp/", pageConfig),
        title: "Guide to Customer Data Platforms"
      }]
    }],
    copyright: "\xA9 ".concat(new Date().getUTCFullYear(), " Twilio Inc. All Rights Reserved.")
  };
};

/* harmony default export */ __webpack_exports__["Z"] = (getData);

/***/ }),

/***/ 4009:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* reexport safe */ _Footer__WEBPACK_IMPORTED_MODULE_0__.Z; }
/* harmony export */ });
/* harmony import */ var _Footer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34810);


/***/ }),

/***/ 74048:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95235);
/* harmony import */ var _workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12741);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(58943);



function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}


/**
 * Creates query hook from query factory
 *
 * @param fetchFactory factory function creating [query key, fetchFunction] tuple for use with react-query lib
 * @param useClientInstance hook function returning client instance to use with fetching function
 * @returns hook function wrapping useQuery
 */

var createQueryHook = function createQueryHook(fetchFactory, useClientInstance, defaultOptions) {
  return function (_ref) {
    var args = _ref.args,
        options = _ref.options;
    var instance = useClientInstance();
    return _tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__/* .useQuery.apply */ .a.apply(void 0, (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(fetchFactory.apply(void 0, [instance].concat((0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(args)))).concat([_objectSpread(_objectSpread({}, defaultOptions), options)]));
  };
};

/* harmony default export */ __webpack_exports__["Z"] = (createQueryHook);

/***/ }),

/***/ 10715:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "c": function() { return /* binding */ createFsCacheProxy; }
/* harmony export */ });
/* harmony import */ var _workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toArray_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(95922);
/* harmony import */ var _workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(12741);
/* harmony import */ var _workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(20406);
/* harmony import */ var _workdir_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28526);
/* harmony import */ var _workdir_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_workdir_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__);
/* module decorator */ module = __webpack_require__.hmd(module);




function _createForOfIteratorHelper(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];

  if (!it) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;

      var F = function F() {};

      return {
        s: F,
        n: function n() {
          if (i >= o.length) return {
            done: true
          };
          return {
            done: false,
            value: o[i++]
          };
        },
        e: function e(_e) {
          throw _e;
        },
        f: F
      };
    }

    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  var normalCompletion = true,
      didErr = false,
      err;
  return {
    s: function s() {
      it = it.call(o);
    },
    n: function n() {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    },
    e: function e(_e2) {
      didErr = true;
      err = _e2;
    },
    f: function f() {
      try {
        if (!normalCompletion && it["return"] != null) it["return"]();
      } finally {
        if (didErr) throw err;
      }
    }
  };
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}



function _asyncIterator(iterable) {
  var method,
      async,
      sync,
      retry = 2;

  for ("undefined" != typeof Symbol && (async = Symbol.asyncIterator, sync = Symbol.iterator); retry--;) {
    if (async && null != (method = iterable[async])) return method.call(iterable);
    if (sync && null != (method = iterable[sync])) return new AsyncFromSyncIterator(method.call(iterable));
    async = "@@asyncIterator", sync = "@@iterator";
  }

  throw new TypeError("Object is not async iterable");
}

function AsyncFromSyncIterator(s) {
  function AsyncFromSyncIteratorContinuation(r) {
    if (Object(r) !== r) return Promise.reject(new TypeError(r + " is not an object."));
    var done = r.done;
    return Promise.resolve(r.value).then(function (value) {
      return {
        value: value,
        done: done
      };
    });
  }

  return AsyncFromSyncIterator = function AsyncFromSyncIterator(s) {
    this.s = s, this.n = s.next;
  }, AsyncFromSyncIterator.prototype = {
    s: null,
    n: null,
    next: function next() {
      return AsyncFromSyncIteratorContinuation(this.n.apply(this.s, arguments));
    },
    "return": function _return(value) {
      var ret = this.s["return"];
      return void 0 === ret ? Promise.resolve({
        value: value,
        done: !0
      }) : AsyncFromSyncIteratorContinuation(ret.apply(this.s, arguments));
    },
    "throw": function _throw(value) {
      var thr = this.s["return"];
      return void 0 === thr ? Promise.reject(value) : AsyncFromSyncIteratorContinuation(thr.apply(this.s, arguments));
    }
  }, new AsyncFromSyncIterator(s);
}

function maybeImport(_x) {
  return _maybeImport.apply(this, arguments);
}

function _maybeImport() {
  _maybeImport = (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)( /*#__PURE__*/_workdir_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee3(importFn) {
    return _workdir_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            return _context3.abrupt("return",  false ? 0 : Promise.resolve(null));

          case 1:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _maybeImport.apply(this, arguments);
}

function getPkgJsonDir() {
  return _getPkgJsonDir.apply(this, arguments);
}

function _getPkgJsonDir() {
  _getPkgJsonDir = (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)( /*#__PURE__*/_workdir_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee4() {
    var _yield$import, dirname, _yield$import2, constants, access, errors, _iterator3, _step3, path, prospectivePkgJsonDir;

    return _workdir_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return __webpack_require__.e(/* import() */ 5153).then(__webpack_require__.t.bind(__webpack_require__, 15153, 23));

          case 2:
            _yield$import = _context4.sent;
            dirname = _yield$import.dirname;
            _context4.next = 6;
            return __webpack_require__.e(/* import() */ 8653).then(__webpack_require__.t.bind(__webpack_require__, 68653, 23));

          case 6:
            _yield$import2 = _context4.sent;
            constants = _yield$import2.constants;
            access = _yield$import2.promises.access;
            errors = [];
            _iterator3 = _createForOfIteratorHelper(module.paths);
            _context4.prev = 11;

            _iterator3.s();

          case 13:
            if ((_step3 = _iterator3.n()).done) {
              _context4.next = 27;
              break;
            }

            path = _step3.value;
            _context4.prev = 15;
            prospectivePkgJsonDir = dirname(path); // eslint-disable-next-line no-await-in-loop

            _context4.next = 19;
            return access(path, constants.F_OK);

          case 19:
            return _context4.abrupt("return", prospectivePkgJsonDir);

          case 22:
            _context4.prev = 22;
            _context4.t0 = _context4["catch"](15);
            errors.push(_context4.t0);

          case 25:
            _context4.next = 13;
            break;

          case 27:
            _context4.next = 32;
            break;

          case 29:
            _context4.prev = 29;
            _context4.t1 = _context4["catch"](11);

            _iterator3.e(_context4.t1);

          case 32:
            _context4.prev = 32;

            _iterator3.f();

            return _context4.finish(32);

          case 35:
            throw new Error("Cannot find project root dir. Underlying errors:\n\n ".concat(errors.join("\n")));

          case 36:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4, null, [[11, 29, 32, 35], [15, 22]]);
  }));
  return _getPkgJsonDir.apply(this, arguments);
}

function getCacheFilename(_x2) {
  return _getCacheFilename.apply(this, arguments);
}

function _getCacheFilename() {
  _getCacheFilename = (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)( /*#__PURE__*/_workdir_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee5(key) {
    var indexKey, hashData, _key, head, tail, hashPart, crypto, hashFn, hash;

    return _workdir_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            if (!(!key.length && key.length <= 0)) {
              _context5.next = 2;
              break;
            }

            throw new Error("Cache key is empty");

          case 2:
            hashData = null;

            if (Array.isArray(key)) {
              _key = (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toArray_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(key), head = _key[0], tail = _key.slice(1);
              indexKey = head;
              hashData = tail;
            } else {
              indexKey = key;
            }

            hashPart = "";

            if (!(hashData && hashData.length > 0)) {
              _context5.next = 12;
              break;
            }

            _context5.next = 8;
            return maybeImport(function () {
              return Promise.all(/* import() */[__webpack_require__.e(8934), __webpack_require__.e(8834), __webpack_require__.e(8421)]).then(__webpack_require__.t.bind(__webpack_require__, 71941, 23));
            });

          case 8:
            crypto = _context5.sent;
            hashFn = crypto === null || crypto === void 0 ? void 0 : crypto.createHash("sha1");
            hash = hashFn === null || hashFn === void 0 ? void 0 : hashFn.update(hashData.map(function (v) {
              return typeof v === "string" ? v : JSON.stringify(v);
            }).join("")).digest("hex");

            if (hash) {
              hashPart = "-".concat(hash);
            }

          case 12:
            return _context5.abrupt("return", "".concat(indexKey).concat(hashPart));

          case 13:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));
  return _getCacheFilename.apply(this, arguments);
}

function getDefaultCacheDirPath() {
  return _getDefaultCacheDirPath.apply(this, arguments);
}

function _getDefaultCacheDirPath() {
  _getDefaultCacheDirPath = (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)( /*#__PURE__*/_workdir_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee6() {
    var path;
    return _workdir_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            _context6.next = 2;
            return __webpack_require__.e(/* import() */ 5153).then(__webpack_require__.t.bind(__webpack_require__, 15153, 23));

          case 2:
            path = _context6.sent;
            _context6.t0 = path;
            _context6.next = 6;
            return getPkgJsonDir();

          case 6:
            _context6.t1 = _context6.sent;
            return _context6.abrupt("return", _context6.t0.resolve.call(_context6.t0, _context6.t1, "node_modules/.cache/fsCache"));

          case 8:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));
  return _getDefaultCacheDirPath.apply(this, arguments);
}

function invariantCacheFilePresent(_x3) {
  return _invariantCacheFilePresent.apply(this, arguments);
}

function _invariantCacheFilePresent() {
  _invariantCacheFilePresent = (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)( /*#__PURE__*/_workdir_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee7(cacheFilePath) {
    var _yield$import3, constants, fs;

    return _workdir_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            _context7.next = 2;
            return __webpack_require__.e(/* import() */ 8653).then(__webpack_require__.t.bind(__webpack_require__, 68653, 23));

          case 2:
            _yield$import3 = _context7.sent;
            constants = _yield$import3.constants;
            fs = _yield$import3.promises;
            _context7.next = 7;
            return fs.access(cacheFilePath, constants.F_OK);

          case 7:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7);
  }));
  return _invariantCacheFilePresent.apply(this, arguments);
}

function ensureCacheDirExists(_x4) {
  return _ensureCacheDirExists.apply(this, arguments);
}

function _ensureCacheDirExists() {
  _ensureCacheDirExists = (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)( /*#__PURE__*/_workdir_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee8(cacheDirPath) {
    var _yield$import4, constants, fs;

    return _workdir_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            _context8.next = 2;
            return __webpack_require__.e(/* import() */ 8653).then(__webpack_require__.t.bind(__webpack_require__, 68653, 23));

          case 2:
            _yield$import4 = _context8.sent;
            constants = _yield$import4.constants;
            fs = _yield$import4.promises;
            _context8.prev = 5;
            _context8.next = 8;
            return fs.access(cacheDirPath, constants.F_OK);

          case 8:
            _context8.next = 18;
            break;

          case 10:
            _context8.prev = 10;
            _context8.t0 = _context8["catch"](5);

            if (!(_context8.t0.code === "ENOENT")) {
              _context8.next = 17;
              break;
            }

            _context8.next = 15;
            return fs.mkdir(cacheDirPath, {
              recursive: true
            });

          case 15:
            _context8.next = 18;
            break;

          case 17:
            throw _context8.t0;

          case 18:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8, null, [[5, 10]]);
  }));
  return _ensureCacheDirExists.apply(this, arguments);
}

function isCacheStale(metadata, staleTime) {
  return metadata.time - Date.now() + staleTime * 1000 < 0;
}

function loadCacheMetadata(_x5) {
  return _loadCacheMetadata.apply(this, arguments);
}

function _loadCacheMetadata() {
  _loadCacheMetadata = (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)( /*#__PURE__*/_workdir_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee9(cacheFilePath) {
    var fs, readline, readable, readInterface, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, line;

    return _workdir_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            _context9.next = 2;
            return __webpack_require__.e(/* import() */ 8653).then(__webpack_require__.t.bind(__webpack_require__, 68653, 23));

          case 2:
            fs = _context9.sent;
            _context9.next = 5;
            return __webpack_require__.e(/* import() */ 6757).then(__webpack_require__.t.bind(__webpack_require__, 16757, 23));

          case 5:
            readline = _context9.sent;
            readable = fs.createReadStream(cacheFilePath);
            readInterface = readline.createInterface({
              input: readable,
              crlfDelay: Infinity
            }); // eslint-disable-next-line no-unreachable-loop

            _iteratorAbruptCompletion = false;
            _didIteratorError = false;
            _context9.prev = 10;
            _iterator = _asyncIterator(readInterface);

          case 12:
            _context9.next = 14;
            return _iterator.next();

          case 14:
            if (!(_iteratorAbruptCompletion = !(_step = _context9.sent).done)) {
              _context9.next = 20;
              break;
            }

            line = _step.value;
            return _context9.abrupt("return", JSON.parse(line));

          case 17:
            _iteratorAbruptCompletion = false;
            _context9.next = 12;
            break;

          case 20:
            _context9.next = 26;
            break;

          case 22:
            _context9.prev = 22;
            _context9.t0 = _context9["catch"](10);
            _didIteratorError = true;
            _iteratorError = _context9.t0;

          case 26:
            _context9.prev = 26;
            _context9.prev = 27;

            if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) {
              _context9.next = 31;
              break;
            }

            _context9.next = 31;
            return _iterator["return"]();

          case 31:
            _context9.prev = 31;

            if (!_didIteratorError) {
              _context9.next = 34;
              break;
            }

            throw _iteratorError;

          case 34:
            return _context9.finish(31);

          case 35:
            return _context9.finish(26);

          case 36:
            throw new Error("Cannot load cache metadata");

          case 37:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee9, null, [[10, 22, 26, 36], [27,, 31, 35]]);
  }));
  return _loadCacheMetadata.apply(this, arguments);
}

function loadCachedData(_x6) {
  return _loadCachedData.apply(this, arguments);
}

function _loadCachedData() {
  _loadCachedData = (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)( /*#__PURE__*/_workdir_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee10(cacheFilePath) {
    var fs, readline, readable, readInterface, data, isFirstLine, _iteratorAbruptCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, line;

    return _workdir_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee10$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            _context10.next = 2;
            return __webpack_require__.e(/* import() */ 8653).then(__webpack_require__.t.bind(__webpack_require__, 68653, 23));

          case 2:
            fs = _context10.sent;
            _context10.next = 5;
            return __webpack_require__.e(/* import() */ 6757).then(__webpack_require__.t.bind(__webpack_require__, 16757, 23));

          case 5:
            readline = _context10.sent;
            readable = fs.createReadStream(cacheFilePath);
            readInterface = readline.createInterface({
              input: readable,
              crlfDelay: Infinity
            });
            data = "";
            isFirstLine = true;
            _iteratorAbruptCompletion2 = false;
            _didIteratorError2 = false;
            _context10.prev = 12;
            _iterator2 = _asyncIterator(readInterface);

          case 14:
            _context10.next = 16;
            return _iterator2.next();

          case 16:
            if (!(_iteratorAbruptCompletion2 = !(_step2 = _context10.sent).done)) {
              _context10.next = 25;
              break;
            }

            line = _step2.value;

            if (!isFirstLine) {
              _context10.next = 21;
              break;
            }

            isFirstLine = false;
            return _context10.abrupt("continue", 22);

          case 21:
            data += line;

          case 22:
            _iteratorAbruptCompletion2 = false;
            _context10.next = 14;
            break;

          case 25:
            _context10.next = 31;
            break;

          case 27:
            _context10.prev = 27;
            _context10.t0 = _context10["catch"](12);
            _didIteratorError2 = true;
            _iteratorError2 = _context10.t0;

          case 31:
            _context10.prev = 31;
            _context10.prev = 32;

            if (!(_iteratorAbruptCompletion2 && _iterator2["return"] != null)) {
              _context10.next = 36;
              break;
            }

            _context10.next = 36;
            return _iterator2["return"]();

          case 36:
            _context10.prev = 36;

            if (!_didIteratorError2) {
              _context10.next = 39;
              break;
            }

            throw _iteratorError2;

          case 39:
            return _context10.finish(36);

          case 40:
            return _context10.finish(31);

          case 41:
            return _context10.abrupt("return", JSON.parse(data));

          case 42:
          case "end":
            return _context10.stop();
        }
      }
    }, _callee10, null, [[12, 27, 31, 41], [32,, 36, 40]]);
  }));
  return _loadCachedData.apply(this, arguments);
}

function isSubDir(_x7, _x8) {
  return _isSubDir.apply(this, arguments);
}
/**
 * Creates a file system cache function proxy. It stores function results in the
 * file system and reuses them as long as they are fresh. Useful to cache heavy
 * network requests while building static page via NextJS. Each function with
 * unique key is stored as a separate entry in a location set via options.
 *
 * @param key - globally unique caching key
 * @param fn - fetching function which returned data will be cached
 * @param opts - options object
 * @returns function proxy with caching layer
 */


function _isSubDir() {
  _isSubDir = (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)( /*#__PURE__*/_workdir_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee11(parent, dir) {
    var path, relative;
    return _workdir_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee11$(_context11) {
      while (1) {
        switch (_context11.prev = _context11.next) {
          case 0:
            _context11.next = 2;
            return __webpack_require__.e(/* import() */ 5153).then(__webpack_require__.t.bind(__webpack_require__, 15153, 23));

          case 2:
            path = _context11.sent;
            relative = path.relative(parent, dir);
            return _context11.abrupt("return", relative && !relative.startsWith("..") && !path.isAbsolute(relative));

          case 5:
          case "end":
            return _context11.stop();
        }
      }
    }, _callee11);
  }));
  return _isSubDir.apply(this, arguments);
}

var createFsCacheProxy = /*#__PURE__*/function () {
  var _ref2 = (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)( /*#__PURE__*/_workdir_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee2(key, fn, _ref) {
    var enabled, _ref$staleTime, staleTime, _ref$cacheDirPath, userCacheDirPath, fsClassic, path, fs, cacheDirPath, cacheFilename, cacheFilePath, targetCacheDirPath;

    return _workdir_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            enabled = _ref.enabled, _ref$staleTime = _ref.staleTime, staleTime = _ref$staleTime === void 0 ? 300 : _ref$staleTime, _ref$cacheDirPath = _ref.cacheDirPath, userCacheDirPath = _ref$cacheDirPath === void 0 ? "/workdir/apps/segment/node_modules/.cache/fsCache" : _ref$cacheDirPath;
            _context2.next = 3;
            return maybeImport(function () {
              return __webpack_require__.e(/* import() */ 8653).then(__webpack_require__.t.bind(__webpack_require__, 68653, 23));
            });

          case 3:
            fsClassic = _context2.sent;
            _context2.next = 6;
            return maybeImport(function () {
              return __webpack_require__.e(/* import() */ 5153).then(__webpack_require__.t.bind(__webpack_require__, 15153, 23));
            });

          case 6:
            path = _context2.sent;

            if (!(!fsClassic || !path || !enabled || true)) {}

            return _context2.abrupt("return", fn);

          case 9:
            fs = fsClassic.promises;
            _context2.t0 = path;

            if (!(userCacheDirPath !== null && userCacheDirPath !== void 0)) {
              _context2.next = 15;
              break;
            }

            _context2.t1 = userCacheDirPath;
            _context2.next = 18;
            break;

          case 15:
            _context2.next = 17;
            return getDefaultCacheDirPath();

          case 17:
            _context2.t1 = _context2.sent;

          case 18:
            _context2.t2 = _context2.t1;
            cacheDirPath = _context2.t0.resolve.call(_context2.t0, _context2.t2);
            _context2.next = 22;
            return getCacheFilename(key);

          case 22:
            cacheFilename = _context2.sent;
            cacheFilePath = path.resolve(cacheDirPath, cacheFilename);
            targetCacheDirPath = path.dirname(cacheFilePath);
            _context2.t3 = cacheDirPath !== targetCacheDirPath;

            if (!_context2.t3) {
              _context2.next = 30;
              break;
            }

            _context2.next = 29;
            return isSubDir(cacheDirPath, targetCacheDirPath);

          case 29:
            _context2.t3 = !_context2.sent;

          case 30:
            if (!_context2.t3) {
              _context2.next = 32;
              break;
            }

            throw new Error("Cache file tries to jailbreak cache dir. Make sure that cache key doesn't start with eg. \"../\".");

          case 32:
            return _context2.abrupt("return", new Proxy(fn, {
              apply: function apply(target, _that, args) {
                return (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)( /*#__PURE__*/_workdir_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                  var metadata, isCacheStaleValue, result, newCacheMetadata, stringifiedMetadata, dataToCache, cachePayload;
                  return _workdir_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          _context.prev = 0;
                          _context.next = 3;
                          return invariantCacheFilePresent(cacheFilePath);

                        case 3:
                          _context.next = 5;
                          return loadCacheMetadata(cacheFilePath);

                        case 5:
                          metadata = _context.sent;
                          _context.next = 8;
                          return isCacheStale(metadata, staleTime);

                        case 8:
                          isCacheStaleValue = _context.sent;

                          if (isCacheStaleValue) {
                            _context.next = 11;
                            break;
                          }

                          return _context.abrupt("return", loadCachedData(cacheFilePath));

                        case 11:
                          _context.next = 15;
                          break;

                        case 13:
                          _context.prev = 13;
                          _context.t0 = _context["catch"](0);

                        case 15:
                          _context.next = 17;
                          return target.apply(void 0, (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(args));

                        case 17:
                          result = _context.sent;
                          newCacheMetadata = {
                            time: Date.now()
                          };
                          stringifiedMetadata = JSON.stringify(newCacheMetadata);
                          _context.prev = 20;
                          dataToCache = JSON.stringify(result);
                          _context.next = 27;
                          break;

                        case 24:
                          _context.prev = 24;
                          _context.t1 = _context["catch"](20);
                          throw new Error("Failed to JSON stringify result. Caching only supported for simple data.\n\n Inner exception: \n".concat(dataToCache));

                        case 27:
                          cachePayload = stringifiedMetadata + "\n" + dataToCache;
                          _context.next = 30;
                          return ensureCacheDirExists(targetCacheDirPath);

                        case 30:
                          _context.next = 32;
                          return fs.writeFile(cacheFilePath, cachePayload, {
                            encoding: "utf8"
                          });

                        case 32:
                          return _context.abrupt("return", result);

                        case 33:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee, null, [[0, 13], [20, 24]]);
                }))();
              }
            }));

          case 33:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function createFsCacheProxy(_x9, _x10, _x11) {
    return _ref2.apply(this, arguments);
  };
}();

/***/ }),

/***/ 96904:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "c": function() { return /* reexport safe */ _fsCache__WEBPACK_IMPORTED_MODULE_0__.c; }
/* harmony export */ });
/* harmony import */ var _fsCache__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(10715);


/***/ }),

/***/ 85807:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ useInView; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
;// CONCATENATED MODULE: ../../libs/utils/useInView/useInView.ts

/**
 * A hook to observe elements in the viewport
 * @param ref - A ref to the element to observe
 * @param options - The options for the IntersectionObserver
 * @returns A boolean indicating if the element is in the viewport
 */

var useIsInView = function useIsInView(ref) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$stopOnIntersecti = _ref.stopOnIntersection,
      stopOnIntersection = _ref$stopOnIntersecti === void 0 ? true : _ref$stopOnIntersecti,
      options = _ref.options;

  var _useState = (0,react.useState)(false),
      isInView = _useState[0],
      setIsInView = _useState[1];

  var inViewRef = (0,react.useRef)(false);
  (0,react.useEffect)(function () {
    var intersectionObserver = new IntersectionObserver(function (intersection) {
      if (intersection.some(function (i) {
        return i.isIntersecting;
      })) {
        inViewRef.current = true;
        setIsInView(true);

        if (stopOnIntersection) {
          intersectionObserver.disconnect();
        }
      } else if (inViewRef.current) {
        inViewRef.current = false;
        setIsInView(false);
      }
    }, options);

    if (ref.current) {
      intersectionObserver.observe(ref.current);
    }

    return function () {
      intersectionObserver.disconnect();
    };
  }, [ref]);
  return isInView;
};

/* harmony default export */ var useInView = (useIsInView);
;// CONCATENATED MODULE: ../../libs/utils/useInView/index.ts


/***/ }),

/***/ 5816:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/events/customer-success",
      function () {
        return __webpack_require__(59708);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 44425:
/***/ (function(module) {

module.exports = "/_next/static/images/OgEvents-d49a5318fa727a13f223d8604c3269af.jpg";

/***/ }),

/***/ 91395:
/***/ (function(module) {

module.exports = "/_next/static/images/Hero@2x-dd64214d9d4ccd528ff4de28c8e94aae.png";

/***/ }),

/***/ 76157:
/***/ (function(module) {

module.exports = "/_next/static/images/Hero-ac76e7a09dde3017fe97a57afe82d66b.webp";

/***/ }),

/***/ 97504:
/***/ (function(module) {

module.exports = "/_next/static/images/Hero@2x-65997089ec59e5a1e8dd3ba90193847a.webp";

/***/ }),

/***/ 95922:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _toArray; }
/* harmony export */ });
/* harmony import */ var _arrayWithHoles_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(64034);
/* harmony import */ var _iterableToArray_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(17602);
/* harmony import */ var _unsupportedIterableToArray_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(57211);
/* harmony import */ var _nonIterableRest_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(42330);




function _toArray(arr) {
  return (0,_arrayWithHoles_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(arr) || (0,_iterableToArray_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(arr) || (0,_unsupportedIterableToArray_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(arr) || (0,_nonIterableRest_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
}

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3287,9097,6577,3607,9137,3254,9129,8943,1382,4136,2073,8392,5735,2429,7303,948,8187,3996,7947,7960,6012,442,4881,9550,9774,2888,179], function() { return __webpack_exec__(5816); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);